import React from "react";
import "../css/homepage.css";
import "flag-icons/css/flag-icons.min.css";
import MapliLogoOrange from "../assets/images/Oransje_Logo.svg";
import { useLanguage } from "../LanguageContext";
import * as text from "../translation.json";

const HeaderHomepage = (props) => {
  const { language, setLanguage } = useLanguage();

  return (
    <header className='homepageHeader'>
      <a href='/' className='headerLeft'>
        <img src={MapliLogoOrange} height='40px' />
      </a>
      <div className='headerRight'>
        {/* <a href='/prices' className='headerPrices'>
          Priser
        </a> */}
        <div style={{ display: "flex", gap: 8, marginRight: 20 }}>
          <span
            className='fi fi-gb'
            onClick={() => setLanguage("en")}
            style={{
              cursor: "pointer",
              display: language === "en" ? "none" : "flex",
            }}
            title='English'
          />

          <span
            className='fi fi-no'
            onClick={() => setLanguage("no")}
            style={{
              cursor: "pointer",
              display: language === "no" ? "none" : "flex",
            }}
            title='Norsk'
          />
        </div>
        <a href='/faq' className='headerPrices'>
          FAQ
        </a>
        <a href='/login'>
          <p className='businessPageLoginButton'>{text[language].loginbtn}</p>
        </a>
      </div>
    </header>
  );
};

export default HeaderHomepage;
